import { IncidentDetailContext } from "@/contexts"
import { useContext } from "react"

export const useIncidentDetailContext = () => {
  const context = useContext(IncidentDetailContext)

  if (!context) throw new Error('useIncidentDetailContext have to be wrapped by IncidentDetailContextPropvider')

  return context
}